import { Component, Input } from '@angular/core'
import { AbstractControl } from '@angular/forms'
import { ValidationMessageService } from '../services/validation-message.service'

@Component({
  selector: 'validation-messages',
  templateUrl: './validation-messages.component.html',
  styleUrls: ['./validation-messages.component.scss'],
})
export class ValidationMessagesComponent {

  @Input() control: AbstractControl

  constructor(
    private readonly validationMessageService: ValidationMessageService,
  ) {}

  get validationMessage() : string {
    if(this.control?.status === 'INVALID' && this.control?.touched){
      for (const propertyName in this.control.errors) {
        return this.validationMessageService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName])
      }
    }
    return null
  }

}
